import { boot } from "quasar/wrappers";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

export default boot((state) => {
  // TODO:
  // try { ... } catch (error) {
  //   Sentry.captureException(error);
  // }
  try {
    Sentry.init({
      app: state.app,
      release: (window as any).VERSION_CLIENT,
      environment: process.env.NODE_ENV,
      dsn: "https://39598bbc7fc844dcb2fa26ec136d1f35@sentry.ocas.ai//4",
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(state.router),
        }),
      ],
      tracesSampleRate: 1.0,
      logErrors: true,
      normalizeDepth: 5,
    });
  } catch (error) {
    console.log("ERROR[Sentry]", error);
  }
});
